import React, { useState, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import SelectTab from '../share/SelectTab';
import Total from './total/total';
import Items from './items/items';
import Cancel from './cancel/cancel';

const EanHotelFlow = {
  NEW: '新規',
  CANCEL: 'キャンセル'
} as const;
export type EanHotelFlowType = keyof typeof EanHotelFlow;

const EanHotelTab = {
  TOTAL: '総数',
  ITEMS: '全件'
} as const;
export type EanHotelTabType = keyof typeof EanHotelTab;

const EanHotelCancelTab = {
  ITEMS: '全件'
} as const;
export type EanHotelCancelTabType = keyof typeof EanHotelCancelTab;

const EanHotel = observer(() => {
  const history = useHistory();
  const [eanHotelFlow, setEanHotelFlow] = useState<EanHotelFlowType>(
    (utils.getParam('ean_hotel_flow') as EanHotelFlowType) || 'NEW'
  );
  const [eanHotelTab, setEanHotelTab] = useState<EanHotelTabType>(
    (utils.getParam('ean_hotel_type') as EanHotelTabType) ||
      (utils.getParam('ean_hotel_tab') as EanHotelTabType) ||
      'TOTAL'
  );
  const [eanHotelCancelTab, setEanHotelCancelTab] = useState<EanHotelCancelTabType>('ITEMS');

  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
    currentParams.set('sub_tab', 'EAN_HOTEL');
    if (!currentParams.has('ean_hotel_flow')) {
      currentParams.set('ean_hotel_flow', eanHotelFlow);
    }
    if (!currentParams.has('ean_hotel_type')) {
      currentParams.set('ean_hotel_type', eanHotelFlow === 'CANCEL' ? eanHotelCancelTab : eanHotelTab);
    }
    history.replace(`/arrangement/todo_list?${currentParams.toString()}`);
  }, [history, eanHotelFlow, eanHotelTab, eanHotelCancelTab]);

  const handleFlowChange = useCallback(
    (flow: EanHotelFlowType) => {
      setEanHotelFlow(flow);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'EAN_HOTEL');
      currentParams.set('ean_hotel_flow', flow);
      const innerTab = flow === 'CANCEL' ? eanHotelCancelTab : eanHotelTab;
      currentParams.set('ean_hotel_type', innerTab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history, eanHotelTab, eanHotelCancelTab]
  );

  const handleNewTabChange = useCallback(
    (tab: EanHotelTabType) => {
      setEanHotelTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'EAN_HOTEL');
      currentParams.set('ean_hotel_flow', 'NEW');
      currentParams.set('ean_hotel_type', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  const handleCancelTabChange = useCallback(
    (tab: EanHotelCancelTabType) => {
      setEanHotelCancelTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'EAN_HOTEL');
      currentParams.set('ean_hotel_flow', 'CANCEL');
      currentParams.set('ean_hotel_type', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  return (
    <>
      <SelectTab tabs={EanHotelFlow} currentTab={eanHotelFlow} onChange={handleFlowChange} />
      {eanHotelFlow === 'NEW' ? (
        <>
          <SelectTab tabs={EanHotelTab} currentTab={eanHotelTab} onChange={handleNewTabChange} />
          {eanHotelTab === 'ITEMS' ? <Items /> : <Total />}
        </>
      ) : (
        <>
          <SelectTab tabs={EanHotelCancelTab} currentTab={eanHotelCancelTab} onChange={handleCancelTabChange} />
          <Cancel />
        </>
      )}
    </>
  );
});

export default EanHotel;
